export default {
  FILE: 'file',
  COLLECTION: 'collection',
  FILTER: 'filter',
  PAGE_SECTION: 'pageSection',
  PAGE_SECTION_ITEM: 'pageSectionItem',
  COLLECTION_GROUP: 'collectionGroupItem',
  COLLECTION_GROUP_GROUP: 'collectionGroupGroup',
  CUSTOM_CATEGORY: 'customCategory',
  CUSTOM_FIELD: 'customField',
  IMAGE_EDITOR_PRESET: 'imageEditorPreset',
};
